function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailCampaignBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.16,210.57S30.94,289,89.6,351.89s148.49,81.68,221,98.83,133.78-14.83,150-75.93-37.29-88.79-58.71-165S386.1,110.6,327.44,56.13,165.13,11.77,103.18,78,38.16,210.57,38.16,210.57Z",
    style: {
      fill: "#E5A94B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.16,210.57S30.94,289,89.6,351.89s148.49,81.68,221,98.83,133.78-14.83,150-75.93-37.29-88.79-58.71-165S386.1,110.6,327.44,56.13,165.13,11.77,103.18,78,38.16,210.57,38.16,210.57Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.09,374.66c3-.22,8.82-3.47,8.83-3.47s-3.31-3.2-3.55-3.38c-2.73-2-9.19-4.35-12.29-2.14a4.5,4.5,0,0,0-.57,6.68C13.28,374.38,16.56,374.84,19.09,374.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.16,390.71c2.7-.95,7.17-5.26,7.52-5.61a79.81,79.81,0,0,0,7.87,7.18c1.61,1.29,3.27,2.55,5,3.79-.86-.45-1.62-.85-1.73-.89-3.17-1.24-10-1.77-12.43,1.18A4.5,4.5,0,0,0,37.57,403c2.24,1.49,5.53,1.07,7.92.22s6.32-4.45,7.34-5.42c.65.47,1.29.95,1.94,1.41,3.13,2.24,6.27,4.46,9.28,6.73,1.06.8,2.07,1.63,3.09,2.45-.76-.4-1.4-.73-1.5-.77-3.17-1.24-10-1.77-12.43,1.18a4.51,4.51,0,0,0,1.22,6.6c2.24,1.48,5.53,1.06,7.92.22s5.94-4.11,7.15-5.25c1,.87,2,1.74,3,2.64.63.62,1.28,1.18,1.88,1.84l1.81,1.92c1.1,1.25,2.25,2.54,3.29,3.8.74.87,1.42,1.7,2.11,2.55-1-.81-3.13-2.35-3.31-2.46-3-1.7-9.63-3.27-12.46-.71a4.5,4.5,0,0,0,.2,6.7c2,1.8,5.31,1.89,7.8,1.42,2.75-.53,7.64-3.95,8.25-4.38,1.13,1.4,2.23,2.78,3.24,4.09,2.73,3.52,5,6.65,6.75,9.18l2.24-1.18c-1.86-2.56-4.28-5.78-7.22-9.4-1.15-1.43-2.41-2.93-3.71-4.46a47.49,47.49,0,0,0,3.46-4.59c2.71,1,8.28.81,9,.79.18,1.8.33,3.54.45,5.2.32,4.31.48,8.09.57,11.12l2.43-1.29c-.15-2.84-.38-6.22-.75-10-.17-1.83-.39-3.77-.64-5.77.7-.2,6.45-1.88,8.57-3.7,1.94-1.65,3.94-4.29,3.78-7a4.51,4.51,0,0,0-5.11-4.35c-3.75.61-6.72,6.8-7.23,10.16,0,.2-.12,2.39-.15,3.77-.1-.81-.2-1.6-.31-2.44-.23-1.66-.5-3.31-.78-5.08q-.25-1.27-.51-2.58c-.15-.87-.42-1.76-.63-2.65-.52-2.06-1.16-4.11-1.84-6.17,1.45-.19,6.59-1,8.76-2.31s4.54-3.65,4.79-6.32a4.52,4.52,0,0,0-4.39-5.08c-3.8,0-7.67,5.71-8.69,9-.06.21-.53,2.62-.76,3.95-.42-1.24-.83-2.47-1.3-3.7-1.34-3.56-2.82-7.12-4.27-10.68l-1.31-3.27c.52-.07,6.65-.86,9.08-2.36,2.16-1.34,4.54-3.65,4.78-6.32A4.51,4.51,0,0,0,96,365.08c-3.81,0-7.68,5.71-8.69,8.95-.08.25-.74,3.72-.87,4.61-1-2.4-1.89-4.81-2.71-7.21A80,80,0,0,1,81,361.51c.24,0,6.65-.83,9.14-2.37,2.15-1.34,4.53-3.65,4.78-6.32a4.51,4.51,0,0,0-4.38-5.08c-3.81,0-7.68,5.71-8.69,8.95-.08.26-.8,4-.88,4.68,0-.2-.1-.39-.14-.59a58.55,58.55,0,0,1-.91-10.28c0-1.9.06-3.72.18-5.49,1.21,0,6.73-.2,9.13-1.34s4.9-3.13,5.45-5.76a4.52,4.52,0,0,0-3.8-5.53c-3.79-.38-8.26,4.83-9.63,7.95-.07.17-.64,2-1,3.29.07-.79.12-1.62.2-2.38.29-2.87.74-5.47,1.15-7.78.24-1.31.49-2.48.73-3.58,1.18-.65,5.87-3.3,7.44-5.38s2.92-5,2.18-7.62A4.51,4.51,0,0,0,86,313.73c-3.54,1.4-5.1,8.09-4.88,11.48,0,.3.85,4.85.91,4.81l.07,0c-.25,1.05-.51,2.18-.77,3.43-.46,2.3-1,4.9-1.32,7.77a79.8,79.8,0,0,0-.71,9.31,58.79,58.79,0,0,0,.7,10.43s0,.08,0,.12c-.5-1-2-3.74-2.14-3.93-2-2.78-7.37-7-11-5.87a4.51,4.51,0,0,0-2.62,6.17c1.05,2.47,4,3.94,6.49,4.56,2.78.69,8.88-.44,9.37-.53a79.14,79.14,0,0,0,2.6,10.32c.63,2,1.32,3.94,2,5.9-.46-.85-.88-1.6-.95-1.7-2-2.78-7.37-7-11-5.87a4.51,4.51,0,0,0-2.62,6.17c1.05,2.48,4,3.94,6.48,4.56s7.73-.23,9.11-.48c.29.75.56,1.5.85,2.25,1.37,3.6,2.76,7.18,4,10.73.44,1.25.83,2.5,1.23,3.75-.41-.75-.77-1.38-.83-1.47-2-2.78-7.38-7-11-5.87a4.51,4.51,0,0,0-2.63,6.17c1.06,2.47,4,3.94,6.49,4.56s7.22-.16,8.86-.44c.37,1.29.74,2.58,1,3.85.18.87.42,1.7.56,2.58s.3,1.74.45,2.59c.22,1.66.47,3.37.65,5,.13,1.13.24,2.21.35,3.29-.43-1.25-1.31-3.68-1.41-3.88a17.59,17.59,0,0,0-6-6.44,5.69,5.69,0,0,0-.52-.85,4.51,4.51,0,0,0-6.66-.81c-2.8,2.58-1.85,9.38-.43,12.47.09.18,1.22,2.05,2,3.22-.54-.62-1-1.23-1.61-1.86-1.1-1.26-2.24-2.49-3.45-3.81l-1.85-1.88c-.6-.63-1.32-1.23-2-1.86-1.57-1.42-3.23-2.79-4.93-4.12,1.1-1,5-4.45,6-6.77s1.77-5.54.5-7.91A4.5,4.5,0,0,0,68.89,391c-3.16,2.13-3.26,9-2.32,12.27.06.2,1,2.47,1.54,3.7-1-.79-2-1.59-3.12-2.36-3.08-2.23-6.28-4.39-9.45-6.55l-2.9-2c.4-.34,5.07-4.38,6.27-7,1.06-2.31,1.77-5.54.5-7.91A4.49,4.49,0,0,0,53,379.36c-3.16,2.12-3.26,9-2.31,12.26.07.24,1.43,3.51,1.81,4.32-2.12-1.48-4.22-3-6.24-4.52a79.82,79.82,0,0,1-7.76-6.76c.18-.16,5.09-4.36,6.31-7,1.06-2.3,1.78-5.54.51-7.91a4.51,4.51,0,0,0-6.46-1.81c-3.16,2.13-3.26,9-2.31,12.26.07.26,1.54,3.77,1.85,4.38l-.44-.41a57.56,57.56,0,0,1-6.43-8.07c-1.07-1.58-2-3.14-2.88-4.68,1-.69,5.5-3.89,6.87-6.16s2.37-5.31,1.37-7.8a4.51,4.51,0,0,0-6.22-2.52c-3.37,1.77-4.22,8.59-3.64,11.94,0,.18.55,2,1,3.31-.38-.7-.79-1.42-1.14-2.1-1.34-2.55-2.41-5-3.34-7.11-.51-1.23-1-2.35-1.36-3.4.62-1.18,3.07-6,3.23-8.58S25,343.17,23,341.42a4.51,4.51,0,0,0-6.68.63c-2.18,3.12.21,9.56,2.27,12.27.18.24,3.38,3.57,3.41,3.51l0-.07c.37,1,.78,2.11,1.24,3.29.89,2.17,1.91,4.62,3.19,7.21A79.58,79.58,0,0,0,31,376.42a59,59,0,0,0,6.33,8.31l.09.09c-1-.56-3.73-2-4-2.1-3.17-1.24-10-1.77-12.42,1.18a4.5,4.5,0,0,0,1.21,6.59C24.48,392,27.76,391.56,30.16,390.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6,344.46c.07,0-1-4.5-1.1-4.78-1.15-3.2-5.26-8.7-9.07-8.57a4.52,4.52,0,0,0-4.16,5.26c.37,2.67,2.84,4.87,5.06,6.11C72.93,343.94,79.59,344.46,79.6,344.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.23,374.66c-3-.22-8.82-3.47-8.82-3.47s3.31-3.2,3.54-3.38c2.73-2,9.2-4.35,12.3-2.14a4.5,4.5,0,0,1,.56,6.68C485,374.38,481.76,374.84,479.23,374.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.17,390.71c-2.7-.95-7.17-5.26-7.53-5.61a78.69,78.69,0,0,1-7.87,7.18c-1.61,1.29-3.27,2.55-4.95,3.79.85-.45,1.62-.85,1.73-.89,3.17-1.24,10-1.77,12.42,1.18a4.5,4.5,0,0,1-1.22,6.59c-2.24,1.49-5.52,1.07-7.92.22s-6.32-4.45-7.33-5.42l-1.95,1.41c-3.13,2.24-6.26,4.46-9.27,6.73-1.06.8-2.08,1.63-3.1,2.45.76-.4,1.4-.73,1.51-.77,3.16-1.24,10-1.77,12.42,1.18a4.51,4.51,0,0,1-1.22,6.6c-2.24,1.48-5.53,1.06-7.92.22s-5.94-4.11-7.15-5.25c-1,.87-2,1.74-3,2.64-.64.62-1.29,1.18-1.89,1.84s-1.21,1.28-1.8,1.92c-1.11,1.25-2.25,2.54-3.3,3.8-.73.87-1.42,1.7-2.11,2.55,1.05-.81,3.13-2.35,3.32-2.46,2.94-1.7,9.63-3.27,12.45-.71a4.5,4.5,0,0,1-.2,6.7c-2,1.8-5.3,1.89-7.8,1.42-2.74-.53-7.63-3.95-8.24-4.38-1.14,1.4-2.23,2.78-3.25,4.09-2.72,3.52-5,6.65-6.75,9.18L404,435.73c1.86-2.56,4.29-5.78,7.22-9.4,1.15-1.43,2.41-2.93,3.72-4.46a48.72,48.72,0,0,1-3.47-4.59c-2.71,1-8.28.81-9,.79-.17,1.8-.33,3.54-.45,5.2-.32,4.31-.48,8.09-.56,11.12l-2.44-1.29c.15-2.84.39-6.22.75-10,.18-1.83.4-3.77.64-5.77-.7-.2-6.44-1.88-8.57-3.7-1.93-1.65-3.93-4.29-3.77-7a4.5,4.5,0,0,1,5.1-4.35c3.76.61,6.72,6.8,7.23,10.16,0,.2.12,2.39.15,3.77.11-.81.2-1.6.32-2.44.22-1.66.49-3.31.78-5.08.16-.85.33-1.71.5-2.58s.42-1.76.63-2.65c.53-2.06,1.16-4.11,1.84-6.17-1.45-.19-6.59-1-8.76-2.31s-4.54-3.65-4.78-6.32a4.51,4.51,0,0,1,4.38-5.08c3.81,0,7.68,5.71,8.69,9,.07.21.53,2.62.76,3.95.42-1.24.84-2.47,1.3-3.7,1.35-3.56,2.82-7.12,4.27-10.68.45-1.09.88-2.18,1.31-3.27-.51-.07-6.65-.86-9.08-2.36-2.15-1.34-4.53-3.65-4.78-6.32a4.51,4.51,0,0,1,4.38-5.08c3.81,0,7.68,5.71,8.7,8.95.07.25.74,3.72.86,4.61,1-2.4,1.89-4.81,2.72-7.21a79.88,79.88,0,0,0,2.74-9.92c-.24,0-6.64-.83-9.13-2.37-2.16-1.34-4.54-3.65-4.79-6.32a4.52,4.52,0,0,1,4.39-5.08c3.81,0,7.67,5.71,8.69,8.95.08.26.79,4,.87,4.68,0-.2.11-.39.14-.59a57.61,57.61,0,0,0,.91-10.28c0-1.9-.06-3.72-.18-5.49-1.21,0-6.73-.2-9.12-1.34s-4.91-3.13-5.45-5.76a4.51,4.51,0,0,1,3.8-5.53c3.79-.38,8.26,4.83,9.62,7.95.08.17.64,2,1,3.29-.07-.79-.12-1.62-.2-2.38-.29-2.87-.73-5.47-1.15-7.78-.24-1.31-.49-2.48-.73-3.58-1.17-.65-5.86-3.3-7.43-5.38s-2.92-5-2.19-7.62a4.51,4.51,0,0,1,5.92-3.15c3.54,1.4,5.1,8.09,4.88,11.48,0,.3-.85,4.85-.91,4.81l-.07,0c.25,1.05.52,2.18.78,3.43.46,2.3,1,4.9,1.32,7.77a79.89,79.89,0,0,1,.7,9.31,58.76,58.76,0,0,1-.69,10.43l0,.12c.5-1,2-3.74,2.14-3.93,2-2.78,7.37-7,11-5.87a4.5,4.5,0,0,1,2.62,6.17c-1.05,2.47-4,3.94-6.48,4.56-2.78.69-8.89-.44-9.38-.53a79.14,79.14,0,0,1-2.6,10.32c-.63,2-1.32,3.94-2,5.9.46-.85.88-1.6.95-1.7,2-2.78,7.38-7,11-5.87a4.51,4.51,0,0,1,2.63,6.17c-1.06,2.48-4,3.94-6.49,4.56s-7.73-.23-9.11-.48l-.84,2.25c-1.38,3.6-2.77,7.18-4,10.73-.44,1.25-.83,2.5-1.22,3.75.41-.75.76-1.38.82-1.47,2-2.78,7.38-7,11-5.87a4.51,4.51,0,0,1,2.62,6.17c-1.06,2.47-4,3.94-6.49,4.56s-7.22-.16-8.86-.44c-.36,1.29-.73,2.58-1,3.85-.18.87-.42,1.7-.55,2.58s-.3,1.74-.45,2.59c-.23,1.66-.47,3.37-.65,5-.14,1.13-.25,2.21-.36,3.29.43-1.25,1.32-3.68,1.41-3.88A17.54,17.54,0,0,1,410,407a4.41,4.41,0,0,1,.52-.85,4.5,4.5,0,0,1,6.65-.81c2.8,2.58,1.86,9.38.43,12.47-.09.18-1.22,2.05-2,3.22.54-.62,1.06-1.23,1.62-1.86,1.1-1.26,2.23-2.49,3.45-3.81l1.84-1.88c.61-.63,1.33-1.23,2-1.86,1.57-1.42,3.23-2.79,4.94-4.12-1.1-1-5-4.45-6-6.77s-1.78-5.54-.51-7.91a4.51,4.51,0,0,1,6.46-1.82c3.16,2.13,3.25,9,2.31,12.27-.06.2-1,2.47-1.54,3.7,1-.79,2.05-1.59,3.12-2.36,3.09-2.23,6.28-4.39,9.46-6.55l2.89-2c-.39-.34-5.07-4.38-6.27-7-1.06-2.31-1.77-5.54-.5-7.91a4.5,4.5,0,0,1,6.46-1.81c3.15,2.12,3.25,9,2.31,12.26-.07.24-1.43,3.51-1.82,4.32,2.13-1.48,4.23-3,6.24-4.52a78.65,78.65,0,0,0,7.76-6.76c-.18-.16-5.08-4.36-6.31-7-1.06-2.3-1.77-5.54-.5-7.91a4.5,4.5,0,0,1,6.45-1.81c3.16,2.13,3.26,9,2.31,12.26-.07.26-1.53,3.77-1.84,4.38l.44-.41a58.21,58.21,0,0,0,6.42-8.07c1.07-1.58,2-3.14,2.88-4.68-1-.69-5.5-3.89-6.86-6.16s-2.37-5.31-1.37-7.8a4.51,4.51,0,0,1,6.22-2.52c3.37,1.77,4.22,8.59,3.64,11.94,0,.18-.56,2-1,3.31.38-.7.79-1.42,1.15-2.1,1.34-2.55,2.4-5,3.33-7.11.52-1.23,1-2.35,1.37-3.4-.63-1.18-3.07-6-3.24-8.58s.35-5.81,2.38-7.56a4.51,4.51,0,0,1,6.68.63c2.18,3.12-.21,9.56-2.26,12.27-.18.24-3.39,3.57-3.42,3.51l0-.07c-.36,1-.77,2.11-1.24,3.29-.88,2.17-1.9,4.62-3.19,7.21a79.58,79.58,0,0,1-4.55,8.16,57.49,57.49,0,0,1-6.33,8.31l-.09.09c1-.56,3.73-2,4-2.1,3.16-1.24,10-1.77,12.42,1.18a4.5,4.5,0,0,1-1.22,6.59C473.85,392,470.56,391.56,468.17,390.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.73,344.46c-.07,0,1-4.5,1.09-4.78,1.15-3.2,5.27-8.7,9.07-8.57a4.51,4.51,0,0,1,4.16,5.26c-.36,2.67-2.84,4.87-5.05,6.11C425.4,343.94,418.73,344.46,418.73,344.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 92.23,
    y1: 200.6,
    x2: 93.06,
    y2: 201.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.74,
    y1: 202.24,
    x2: 247.97,
    y2: 301.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "1.9975500106811523,1.9975500106811523"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "248.81 302.42 249.64 302.96 249.1 302.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 248.02,
    y1: 300.46,
    x2: 116.58,
    y2: 98.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "1.9842400550842285,1.9842400550842285"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.03,
    y1: 97.53,
    x2: 115.49,
    y2: 96.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 407.06,
    y1: 200.6,
    x2: 406.23,
    y2: 201.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.55,
    y1: 202.24,
    x2: 251.32,
    y2: 301.87,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "1.9975500106811523,1.9975500106811523"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "250.48 302.42 249.64 302.96 250.19 302.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.27,
    y1: 300.46,
    x2: 382.71,
    y2: 98.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "1.9842400550842285,1.9842400550842285"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.25,
    y1: 97.53,
    x2: 383.8,
    y2: 96.69,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.64,
    y1: 65.67,
    x2: 249.64,
    y2: 66.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.64,
    y1: 68.68,
    x2: 249.64,
    y2: 300.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeDasharray: "2.011039972305298,2.011039972305298"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.64,
    y1: 301.96,
    x2: 249.64,
    y2: 302.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.51,
    cy: 61.15,
    r: 30.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.51,61.15l25.88-16.6a30.82,30.82,0,0,0-16.3-12.62Z",
    style: {
      fill: "#E5A94B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.51,61.15,266,88.26a30.75,30.75,0,0,0,11.35-43.71Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.67,
    cy: 96.5,
    r: 30.74,
    transform: "translate(42.68 296.02) rotate(-45)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.67,
    cy: 96.5,
    r: 26.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394 96.5 368.19 81.59 368.19 111.4 394 96.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.72,
    cy: 196.79,
    r: 32.08,
    transform: "translate(132.88 562.03) rotate(-76.53)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.72,
    cy: 196.79,
    r: 22.91,
    transform: "translate(133.22 562.31) rotate(-76.58)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.72,
    cy: 196.79,
    r: 13.75,
    transform: "translate(133.56 562.58) rotate(-76.64)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.72,
    cy: 196.79,
    r: 7.4,
    transform: "translate(133.8 562.77) rotate(-76.67)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.6,181.4l-4.08-1.59,1.78-.87a.85.85,0,1,0-.74-1.53l-1.29.63,2.05-4.44L453.71,177l-1.11,4.27L422.35,196a.85.85,0,0,0-.39,1.14.83.83,0,0,0,1.13.39l30.35-14.78,3.31,1.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.17,
    cy: 95.16,
    r: 32.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.17,
    cy: 95.16,
    rx: 23.26,
    ry: 32.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.17,
    cy: 95.16,
    rx: 9.9,
    ry: 32.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.18,
    y1: 68.07,
    x2: 135.73,
    y2: 68.07,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.56,
    y1: 80.64,
    x2: 146.73,
    y2: 80.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.26,
    y1: 93.2,
    x2: 150.18,
    y2: 93.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.67,
    y1: 105.77,
    x2: 148.3,
    y2: 105.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.31,
    y1: 118.33,
    x2: 140.6,
    y2: 118.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.19,
    cy: 196.79,
    r: 32.07,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.98,
    y: 181.63,
    width: 42.53,
    height: 34.03,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.32,
    y: 181.63,
    width: 47.85,
    height: 13.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2,181.29s-10-11.71-11.71-11.15-6.13,8.36-3.62,9.2S75.2,181.29,75.2,181.29Z",
    style: {
      fill: "#E5A94B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,181.29s10-11.71,11.71-11.15,6.14,8.36,3.63,9.2S75.29,181.29,75.29,181.29Z",
    style: {
      fill: "#E5A94B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.27 205.55 75.26 200.32 72.14 205.55 72.14 182.13 78.27 182.13 78.27 205.55",
    style: {
      fill: "#E5A94B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mail--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "90.39 285.14 249.53 195.57 412.57 285.14 412.57 414.99 92.35 414.99 90.39 285.14",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.38,
    y: 219.73,
    width: 238.22,
    height: 211.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.71,
    y1: 256.83,
    x2: 340.33,
    y2: 256.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.71,
    y1: 275.38,
    x2: 340.33,
    y2: 275.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.71,
    y1: 293.93,
    x2: 340.33,
    y2: 293.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.71,
    y1: 312.48,
    x2: 340.33,
    y2: 312.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.71,
    y1: 331.03,
    x2: 340.33,
    y2: 331.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.71,
    y1: 349.58,
    x2: 340.33,
    y2: 349.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.57 463.81 90.39 463.81 90.39 285.14 251.49 394.49 412.57 285.14 412.57 463.81",
    style: {
      fill: "#E5A94B",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.39,
    y1: 463.81,
    x2: 207.53,
    y2: 364.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.06,
    y1: 463.81,
    x2: 295.79,
    y2: 364.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30.31,
    y1: 463.81,
    x2: 470.63,
    y2: 463.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCampaignBro);
export default __webpack_public_path__ + "static/media/Email-campaign-bro.9764068e8c74a016a528e47b20e64f09.svg";
export { ForwardRef as ReactComponent };